export default {
  post_search_result:'搜索結果',
  post_conpy_url:'復製鏈接',
  post_select_circle:'請先選擇一個圈子',
  post_uploading_publish:'附件上傳中，暫時無法發布內容',
  post_pic_overrun:"上傳失敗，圖片數量超限，請刪減後重試",
  post_Success_published:"發布成功",
  post_fileList_limit:'僅支持上傳附件個數為{fileList}個',
  post_file_size_limit: '上傳單個文件大小不得超過{fileSize}M',
  post_file_type_limit:'僅支持上傳PPT、WORD、EXCEL、PDF、圖片、壓縮包、請重新上傳',
  post_Img_size_limit:'圖片大小不得大於3M，請重新上傳',
  post_Img_upload_seccess:'圖片上傳成功',
  post_no_circle_tip:'您未選擇圈子，暫時@不到對應聯系人',
  post_had_click:'您已@該人員',
  post_enter_title:'請輸入標題，標題字數在1～20個字之間',
  post_add_circle:'添加圈子',
  post_enter_context:'請輸入正文內容，字數限製5000個字',
  post_support_type:'支持上傳PPT、WORD、EXCEL、PDF、圖片、壓縮包格式',
  post_add_enclosure:'添加附件',
  post_publishing:'正在發布',
  post_publish:'發布',
  post_upload_failed:'上傳失敗，圖片數量超限，請刪減後重試'
}
